module.exports = __webpack_public_path__ + "img/Frame-44.55f270ee.svg";